import { compose } from "recompose";
import { graphql } from "react-apollo";
import { withGlobalDataLayer } from "theme/modules/Analytics/Datalayer";

const EnhanceCmsPage = ({ CmsPageQuery }) =>
  compose(
    graphql(CmsPageQuery, {
      options: (props) => ({
        variables: {
          identifiers: [props.id],
        },
      }),
      props: ({ data }) => {
        return {
          loading: data.loading,
          cms:
            !data.loading &&
            data.cmsPageList &&
            data.cmsPageList.length > 0 &&
            data.cmsPageList[0],
          sirius_popup: data.sirius_popup,
          robertet_popup: data.robertet_popup,
        };
      },
    }),
    withGlobalDataLayer
  );

export default EnhanceCmsPage;
